<template>
<div class="pp-sidebar">
    <a v-if="!$root.isIos" href="https://pristineclassical.com/" class="pp-sidebar__brand">
        <img src="/assets/images/logo.png">
    </a>

    <a v-if="$root.isIos" href="#" class="pp-sidebar__brand">
        <img src="/assets/images/logo.png">
    </a>

    <router-link to="/browse" class="pp-sidebar__button">
        Browse
    </router-link>

    <router-link to="/browse/new" class="pp-sidebar__button">
        New Releases
    </router-link>

    <router-link to="/browse/composers" class="pp-sidebar__button">
        Composers
    </router-link>

    <router-link to="/browse/ensembles" class="pp-sidebar__button">
        Ensembles
    </router-link>

    <router-link to="/browse/artists" class="pp-sidebar__button">
        Artists
    </router-link>

    <router-link to="/browse/exclusive" class="pp-sidebar__button">
        Exclusives
    </router-link>


    <router-link to="/queue" class="pp-sidebar__button">
        Queue
    </router-link>


    <div v-if="account && account.id" class="pp-sidebar__footer">
        <div class="pp-sidebar__account">
            <div class="pp-sidebar__account__identity">
                Logged in as {{ account.name }}.
                <router-link to="/account">
                    <i class="fa fa-fw fa-info-circle"></i>
                </router-link>
            </div>
            <div v-if="account.plan" class="pp-sidebar__account__plan">
                Plan: {{ account.plan }}
            </div>
            <div v-if="!account.plan" class="pp-sidebar__account__plan">
                <span v-if="account.freePlays > 0">
                    {{ account.freePlays }} free plays available
                </span>
                <span v-if="account.freePlays == 0">
                    You've used all your free plays
                </span>
                -
                <a v-if="!root.isIos" href="https://www.pristineclassical.com/pages/player-subscribe">
                    subscribe
                </a>
            </div>
        </div>
    </div>

    <div v-if="account && !account.id" class="pp-sidebar__footer">
        <div class="pp-sidebar__account">
            <div class="pp-sidebar__account__identity">
                Browsing as guest -
                <a
                    v-if="!$root.isIos"
                    class="pp-sidebar__account__login"
                    href="https://www.pristineclassical.com/pages/player-subscribe" >
                    Log in or register
                </a>
                <a
                    v-if="$root.isIos"
                    class="pp-sidebar__account__login"
                    href="https://www.pristineclassical.com/pages/player-subscribe?signin_hidden=true" >
                    Log in
                </a>
            </div>
            <div class="pp-sidebar__account__plan">
                <span v-if="account.freePlays > 0">
                    {{ account.freePlays }} free plays available
                </span>
                <span v-if="account.freePlays == 0">
                    You've used all your free plays
                </span>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'pp-sidebar',
    data() {
        return {

        };
    },
    props: {
        account: Object,
    }
}
</script>



// WEBPACK FOOTER //
// PpSidebar.vue?fbaf663c